export default __webpack_public_path__ + "static/media/modely.b5abae9e.jpg";